import type { FoodMenuItem } from "@ghostland/shared";

export interface FoodMenuState {
  buildingId: string;
  items: FoodMenuItem[];
  owner: boolean;
  funds: number;
}

type Listener = (s: FoodMenuState) => void;

/**
 * Client mirror of a Watabaga building's live NPC menu (offered items + price + fridge stock). Fed by
 * the server's targeted `FoodMenu` messages; the food-shop panel + the fridge menu-editor subscribe.
 */
class FoodMenuStore {
  private state: FoodMenuState = { buildingId: "", items: [], owner: false, funds: 0 };
  private readonly listeners = new Set<Listener>();

  get(): FoodMenuState { return this.state; }

  set(s: FoodMenuState): void {
    this.state = s;
    for (const fn of this.listeners) fn(this.state);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }
}

export const foodMenuStore = new FoodMenuStore();
